import React, { useEffect } from "react";
import * as bootstrap from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import ReactGA from "react-ga";
const TRACKING_ID = "UA-5168202-7";
ReactGA.initialize(TRACKING_ID);

export const ThankYou = (props) => {
  useEffect(() => {
    ReactGA.pageview(window.location.pathname + window.location.search);
  }, []);
  const { t, i18n } = useTranslation();
  const location = useLocation();
  return (
    <div className="text-center">
      <bootstrap.Container>
        <bootstrap.Row>
          <bootstrap.Col>
            <h2 className="fw-bold py-4">{t("thankYou.thankYou")}</h2>
            <bootstrap.Card>
              <bootstrap.Card.Body>
                <bootstrap.Row>
                  <bootstrap.Col>
                    <p className="lead py-2">
                      {t("thankYou.registrationID")} {location.state.id}
                    </p>
                    <p className="lead py-2">{t("thankYou.message1")}</p>
                    <p className="lead py-1">{t("thankYou.message2")}</p>
                    {location.state.region !== "Armenia" &&
                      location.state.region !== "Bermuda" &&
                      location.state.region !== "Brunei" &&
                      location.state.region !== "Costa Rica" &&
                      location.state.region !== "Ecuador" &&
                      location.state.region !== "Guatemala" &&
                      location.state.region !== "Honduras" &&
                      location.state.region !== "Jordan" &&
                      location.state.region !== "Kyrgyzstan" &&
                      location.state.region !== "Maldives" &&
                      location.state.region !== "Mongolia" &&
                      location.state.region !== "Panama" &&
                      location.state.region !== "Seychelles" &&
                      location.state.region !== "St. Maarten" &&
                      location.state.region !== "Cyprus" && (
                        <p className="lead py-1">{t("thankYou.message3")}</p>
                      )}
                    {(location.state.region === "Armenia" ||
                      location.state.region === "Bermuda" ||
                      location.state.region === "Brunei" ||
                      location.state.region === "Costa Rica" ||
                      location.state.region === "Ecuador" ||
                      location.state.region === "Guatemala" ||
                      location.state.region === "Honduras" ||
                      location.state.region === "Jordan" ||
                      location.state.region === "Kyrgyzstan" ||
                      location.state.region === "Maldives" ||
                      location.state.region === "Mongolia" ||
                      location.state.region === "Panama" ||
                      location.state.region === "Seychelles" ||
                      location.state.region === "St. Maarten") && (
                      <p className="lead py-1">{t("thankYou.message3A")}</p>
                    )}
                    {location.state.region === "Cyprus" && (
                      <p className="lead py-1">{t("thankYou.message3B")}</p>
                    )}

                    {location.state.region === "United States" && (
                      <div>
                        <p className="lead py-1">{t("thankYou.message4")}</p>
                      </div>
                    )}
                    {location.state.region !== "Armenia" &&
                      location.state.region !== "Bermuda" &&
                      location.state.region !== "Brunei" &&
                      location.state.region !== "Costa Rica" &&
                      location.state.region !== "Ecuador" &&
                      location.state.region !== "Guatemala" &&
                      location.state.region !== "Honduras" &&
                      location.state.region !== "Jordan" &&
                      location.state.region !== "Kyrgyzstan" &&
                      location.state.region !== "Maldives" &&
                      location.state.region !== "Mongolia" &&
                      location.state.region !== "Panama" &&
                      location.state.region !== "Seychelles" &&
                      location.state.region !== "St. Maarten" &&
                      location.state.region !== "Cyprus" &&
                      location.state.region !== "United States" && (
                        <p className="lead fw-bold py-1">
                          {t("thankYou.message5")}
                        </p>
                      )}
                    {(location.state.region === "Armenia" ||
                      location.state.region === "Bermuda" ||
                      location.state.region === "Brunei" ||
                      location.state.region === "Costa Rica" ||
                      location.state.region === "Ecuador" ||
                      location.state.region === "Guatemala" ||
                      location.state.region === "Honduras" ||
                      location.state.region === "Jordan" ||
                      location.state.region === "Kyrgyzstan" ||
                      location.state.region === "Maldives" ||
                      location.state.region === "Mongolia" ||
                      location.state.region === "Panama" ||
                      location.state.region === "Seychelles" ||
                      location.state.region === "St. Maarten") && (
                      <p className="lead fw-bold py-1">
                        {t("thankYou.message5A")}
                      </p>
                    )}
                    {location.state.region === "Cyprus" && (
                      <p className="lead fw-bold py-1">
                        {t("thankYou.message5B")}
                      </p>
                    )}
                    {location.state.region !== "Armenia" &&
                      location.state.region !== "Bermuda" &&
                      location.state.region !== "Brunei" &&
                      location.state.region !== "Costa Rica" &&
                      location.state.region !== "Ecuador" &&
                      location.state.region !== "Guatemala" &&
                      location.state.region !== "Honduras" &&
                      location.state.region !== "Jordan" &&
                      location.state.region !== "Kyrgyzstan" &&
                      location.state.region !== "Maldives" &&
                      location.state.region !== "Mongolia" &&
                      location.state.region !== "Panama" &&
                      location.state.region !== "Seychelles" &&
                      location.state.region !== "St. Maarten" &&
                      location.state.region !== "Cyprus" && (
                        <p className="lead fw-bold py-1">
                          {t("thankYou.message6")}
                        </p>
                      )}
                    {(location.state.region === "Armenia" ||
                      location.state.region === "Bermuda" ||
                      location.state.region === "Brunei" ||
                      location.state.region === "Costa Rica" ||
                      location.state.region === "Ecuador" ||
                      location.state.region === "Guatemala" ||
                      location.state.region === "Honduras" ||
                      location.state.region === "Jordan" ||
                      location.state.region === "Kyrgyzstan" ||
                      location.state.region === "Maldives" ||
                      location.state.region === "Mongolia" ||
                      location.state.region === "Panama" ||
                      location.state.region === "Seychelles" ||
                      location.state.region === "St. Maarten") && (
                      <p className="lead fw-bold py-1">
                        {t("thankYou.message6A")}
                      </p>
                    )}
                    {location.state.region === "Cyprus" && (
                      <p className="lead fw-bold py-1">
                        {t("thankYou.message6B")}
                      </p>
                    )}
                    <p className="lead py-1">{t("thankYou.message7")}</p>
                  </bootstrap.Col>
                </bootstrap.Row>
              </bootstrap.Card.Body>
            </bootstrap.Card>
          </bootstrap.Col>
        </bootstrap.Row>
      </bootstrap.Container>
    </div>
  );
};
